import { computed } from 'vue';

const { storeToRefs } = require('pinia');
const { useFiltersStore } = require('stores/filters');

const useFilters = () => {
  const filterStore = useFiltersStore();
  const {
    getFacets,
    getCurrentFilters,
    getCurrentTags,
    getOptionCards,
    getCardSelected,
    getResults,
    getPageInfo,
    getLoading,
    getCurrentOrder,
    getAllResultsCount,
    keywords,
  } = storeToRefs(filterStore);

  const init = async (initialKeywords = null) => {
    await filterStore.init(initialKeywords);
  };

  const handleChangeFilters = async (key, type) => {
    await filterStore.handleChangeFilters(key, type);
  };

  const updateFilters = async updates => {
    await filterStore.updateFilters(updates);
  };

  const getDataFromFilters = async () => {
    const res = await filterStore.getDataFromFilters();
    return res;
  };

  const getTravel = async () => {
    const res = await filterStore.getTravel();
    return res;
  };

  const getBoxes = async () => {
    const res = await filterStore.getBoxes();
    return res;
  };

  const getActivities = async () => {
    const res = await filterStore.getActivities();
    return res;
  };

  const clearCurrentFilters = async (options = {}) => {
    return await filterStore.clearCurrentFilters(options);
  };

  const setCard = (cardId, fireSearch = true) => {
    filterStore.setCard(cardId, fireSearch);
  };

  const setBoxCategory = category => {
    filterStore.setBoxCategory(category);
  };

  const deleteTags = ({ key, inputType, value }) => {
    filterStore.deleteTags({ key, inputType, value });
  };

  const setKeywords = (
    keywords,
    shouldFetch = true,
    shouldUpdateURL = true,
  ) => {
    filterStore.setKeywords(keywords, shouldFetch, shouldUpdateURL);
  };

  const updatePageNumber = pageNumber => {
    filterStore.updatePageNumber(pageNumber);
  };

  const resetPaginationNumber = () => {
    filterStore.resetPaginationNumber();
  };

  const setBoxId = (boxId, shouldFetch = true, shouldUpdateURL = true) => {
    filterStore.setBoxId(boxId, shouldFetch, shouldUpdateURL);
  };

  const applyURLFilters = urlFilters => {
    filterStore.applyURLFilters(urlFilters);
  };

  const registerURLUpdateCallback = callback => {
    filterStore.registerURLUpdateCallback(callback);
  };

  const unregisterURLUpdateCallback = () => {
    filterStore.unregisterURLUpdateCallback();
  };

  const cancelAllRequests = () => {
    filterStore.cancelAllRequests();
  };

  return {
    init,
    handleChangeFilters,
    updateFilters,
    getDataFromFilters,
    getTravel,
    getBoxes,
    getActivities,
    clearCurrentFilters,
    setCard,
    setBoxCategory,
    setKeywords,
    updatePageNumber,
    setBoxId,
    deleteTags,
    resetPaginationNumber,
    applyURLFilters,
    registerURLUpdateCallback,
    unregisterURLUpdateCallback,
    cancelAllRequests,

    // Computed values
    getPageInfo: computed(() => getPageInfo.value),
    getFacets: computed(() => getFacets.value),
    getCurrentFilters: computed(() => getCurrentFilters.value),
    getCurrentTags: computed(() => getCurrentTags.value),
    getOptionCards: computed(() => getOptionCards.value),
    getCardSelected: computed(() => getCardSelected.value),
    getResults: computed(() => getResults.value),
    getLoading: computed(() => getLoading.value),
    getCurrentOrder: computed(() => getCurrentOrder.value),
    getAllResultsCount: computed(() => getAllResultsCount.value),
    getKeywords: computed(() => keywords.value),
  };
};

export default useFilters;
